export type Keys = 'ctv_test_mode' | 'cpb_test_mode' | 'nlc_test_mode' | 'ftc_test_mode' | 'crt_test_mode';

// Reads/writes go through this repo's own serverless function
// (api/edge-config.ts), which holds the Vercel API token server-side. The plugin
// no longer carries any credential. The path is root-relative: the plugin runs
// on the same Vercel deployment that serves the function.
const PROXY_PATH = '/api/edge-config';

// The proxy authenticates the caller with the editor's DatoCMS access token. It's
// only present when the plugin has the `currentUserAccessToken` permission
// granted, so surface a clear error if it's missing rather than sending a
// request the proxy would reject.
export function requireUserToken(ctx: { currentUserAccessToken: string | undefined }): string {
    const token = ctx.currentUserAccessToken;
    if (!token) {
        throw new Error(
            'Missing DatoCMS access token — grant this plugin the "Current user access token" permission.'
        );
    }
    return token;
}

export const updateEdgeConfig = async ({
    key,
    value,
    token,
}: {
    key: Keys;
    value: boolean;
    token: string;
}) => {
    const response = await fetch(PROXY_PATH, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ key, value }),
    });
    if (!response.ok) {
        throw new Error(`Edge Config update failed (${response.status})`);
    }
    return await response.json();
};

export const readEdgeConfigSingleItem = async ({
    key,
    token,
}: {
    key: Keys;
    token: string;
}) => {
    const response = await fetch(`${PROXY_PATH}?key=${key}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    if (!response.ok) {
        throw new Error(`Edge Config read failed (${response.status})`);
    }
    return await response.json();
};
